<template>
  <div>
    <v-toolbar height="50" dark color="grey lighten-1">
      <v-toolbar-title>{{ item ? item.name : '-' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small depressed color="transparent" @click="onClose()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-card flat class="rounded-0 px-2" color="grey lighten-1">
      <v-sheet :style="contentsHeight" class="pa-0 overflow-auto">
        <v-expansion-panels dense>
          <v-expansion-panel
            v-for="(s, i) in slists"
            :key="i"
          >
            <v-expansion-panel-header>
              <v-row>
                <v-col cols="4" class="py-0">{{ s.school.name  }}</v-col>
                <v-col cols="7" class="py-0"></v-col>
                <v-col cols="1" class="py-0" align="center">{{ getErrorCount(s.school.key)  }}</v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <diagnose-item
                :slists="slists"
                :school="s.school.key"
                :errors="errors">
              </diagnose-item>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
    </v-card>

    <div v-if="dialogStudent" class="text-center">
      <v-dialog
        v-model="dialogStudent"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <diagnose-student
          :title="'Diagnose Student'"
          :students="students"
          :student="student"
          @dismissed="onDismissed">
        </diagnose-student>
      </v-dialog>
    </div>

    <div>
      <loading-with-status :loading="loading" :status="status"></loading-with-status>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import * as async from 'async'
import { mapGetters } from 'vuex'
import moment from 'moment'
import TemplateDiagnoseItem from './TemplateDiagnoseItem.vue'
Vue.component('diagnose-item', TemplateDiagnoseItem)

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      windowSize: 'shared/windowSize'
    }),
    item () {
      var temp = {}
      var index = this.schools.findIndex(s => s.key === this.school)
      if (index !== -1) {
        temp = JSON.parse(JSON.stringify(this.schools[index]))
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 50) + 'px;'
    },
    eventsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 50 - (52 * 7) - 1) + 'px;'
    }
  },
  props: ['title', 'metrics_status', 'schools', 'school', 'students'],
  data () {
    return {
      loading: false,
      dialogStudent: false,
      student: null,
      status: '',
      stats: [],
      slists: [],
      errors: [],
      counters: []
    }
  },
  watch: {
  },
  created () {
    //   { key: 1, name: '問合せ' },
    //   { key: 2, name: '保護者面談' },
    //   { key: 3, name: '体験授業' },
    //   { key: 4, name: '提案' },
    //   { key: 5, name: '入塾' },
    //   { key: 6, name: '在籍' },
    //   { key: 7, name: '退塾' },
    //   { key: 8, name: '逸失' }
    //   { key: 1, name: 'DTS' }, // 9
    //   { key: 2, name: '生徒面談' }, // 10
    //   { key: 3, name: '保護者面談' }, // 11
    //   { key: 4, name: 'YCS' }, // 12
    //   { key: 5, name: '約束' }, // 13
    //   { key: 6, name: '退塾' }, // 14
    //   { key: 7, name: 'その他' } // 15
  },
  mounted () {
    var vm = this
    this.slists = []
    if (this.school === '*') {
      var temps = this.schools.filter(m => m.enable)
      vm.loading = true
      async.eachSeries(temps, function (item, cb) {
        vm.makeStatus(item.key, item).then(function (results) {
          vm.slists.push({ school: item, status: results.temp, counters: results.counters })
          cb()
        })
      }, function (error) {
        if (error) {
        }
        vm.makeErrors()
        vm.loading = false
      })
    } else {
      this.loading = true
      this.makeStatus(this.school, vm.item).then(function (results) {
        vm.slists.push({ school: vm.item, status: results.temp, counters: results.counters })
        vm.makeErrors()
        vm.loading = false
      })
    }
  },
  methods: {
    makeStatus (key, school) {
      var temp = []
      var counters = []
      return new Promise(async (resolve) => {
        const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
        var stats = this.metrics_status.filter(m => m.schools[key])
        stats.sort(function (a, b) {
          if (a.mm < b.mm) return -1
          if (a.mm > b.mm) return 1
          return 0
        })
        stats.sort(function (a, b) {
          if (a.yyyy < b.yyyy) return -1
          if (a.yyyy > b.yyyy) return 1
          return 0
        })
        var array = new Array(16).fill(0)
        for (var x in stats) {
          this.status = school.name + ' ' + String(x) + '/' + String(stats.length)
          for (var i = 1; i < 16; i++) {
            if (typeof stats[x][i] !== 'undefined') {
              for (var y in stats[x][i]) {
                if (typeof temp[stats[x][i][y].key] === 'undefined') {
                  temp[stats[x][i][y].key] = []
                  counters[stats[x][i][y].key] = JSON.parse(JSON.stringify(array))
                }
                var data = JSON.parse(JSON.stringify(stats[x][i][y]))
                data['yyyy'] = stats[x].yyyy
                data['mm'] = stats[x].mm
                data['status'] = i
                counters[stats[x][i][y].key][i] += 1
                temp[stats[x][i][y].key].push(data)
              }
            }
          }
          await pause(50).then(() => {
          })
        }
        resolve({ temp: temp, counters: counters })
      })
    },
    makeErrors () {
      for (var y in this.slists) {
        this.errors[this.slists[y].school.key] = {}
        var keys = Object.keys(this.slists[y].counters)
        for (var x in keys) {
          for (var i = 1; i < 8; i++) {
            if (this.slists[y].counters[keys[x]][i] > 1) {
              if (typeof this.errors[this.slists[y].school.key][keys[x]] === 'undefined') {
                this.errors[this.slists[y].school.key][keys[x]] = 1
              }
              continue
            }
          }
        }
      }
    },
    getErrorCount (key) {
      var v = 0
      if (typeof this.errors[key] !== 'undefined') {
        v = Object.keys(this.errors[key]).length
      }
      return String(v)
    },
    onClose () {
      this.$emit('dismissed')
    },
    onDismissed: function (value) {
      if (this.dialogStudent) {
        this.dialogStudent = false
      }
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss.SSS')
    }
  }
}
</script>

<style scoped>
 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

</style>
